import { Box, Typography, Chip } from "@mui/material";
import etiquetasImage from "../../../assets/etiquetas/etiquetas_media_png.png";

const SimpleEtiquetasCard = () => {
  return (
    <Box sx={{ 
      color: "white", 
      py: { xs: 2, lg: 6 },
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "100%"
    }}>
      <Box 
        component="img"
        src={etiquetasImage}
        alt="Sistema de Etiquetas"
        sx={{
          width: "100%",
          height: "auto",
          borderRadius: 3,
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.4)",
          border: "2px solid rgba(255, 255, 255, 0.2)",
          filter: "drop-shadow(0 0 20px rgba(255, 255, 255, 0.1))",
          "&:hover": {
            filter: "drop-shadow(0 0 30px rgba(255, 255, 255, 0.2))",
            transform: "scale(1.02)",
            transition: "all 0.3s ease"
          }
        }}
      />
    </Box>
  );
};

export default SimpleEtiquetasCard;